import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { appConfigService } from '@app/config';
import { KorisnikCitaonice } from '@app/shared/models/korisnik-citaonice';
import {
  AuthRequestOptions,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { first } from 'rxjs';

@Component({
  selector: `app-odabir-korisnika-citaonice`,
  templateUrl: './odabir-korisnika-citaonice.component.html'
})
export class OdabirKorisnikaCitaoniceComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);
  private notificationService = inject(NotificationService);

  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(korisnik: KorisnikCitaonice[]) {
    console.log('selected', korisnik);

    const korisnikId =
      korisnik.length > 0 ? korisnik[0]['en~registrirani_korisnik~id'] : null;

    this.httpClient
      .post(
        `${this.config.apiHost}korisnik-citaonice`,
        korisnikId,
        new AuthRequestOptions()
      )
      .pipe(first())
      .subscribe({
        next: () => {
          const message = 'Korisnik je uspješno dodan';
          this.notificationService.success(message);
          this.listviewProvider.refresh();
        },
        error: () => {
          const errorMessage = 'Greška pri dodavanju korisnika';
          this.notificationService.error(errorMessage);
        },
        complete: () => {
          this.showDialog = false;
        }
      });

    this.showDialog = false;
  }
}
